import { CheckCircle2, Loader2, FileText, Mic, Film, Clapperboard, PartyPopper, XCircle, Music, Download, Image as ImageIcon } from "lucide-react";

const VIDEO_STEPS = [
  { key: "script", label: "Topic & Script", icon: FileText, testid: "pipeline-step-script" },
  { key: "voiceover", label: "Voiceover TTS", icon: Mic, testid: "pipeline-step-voiceover" },
  { key: "visuals", label: "Pexels Visuals", icon: Film, testid: "pipeline-step-visuals" },
  { key: "assembly", label: "Captions & Assembly", icon: Clapperboard, testid: "pipeline-step-assembly" },
  { key: "completed", label: "Final Render", icon: PartyPopper, testid: "pipeline-step-done" },
];

const SONG_STEPS = [
  { key: "script", label: "Lyrics", icon: FileText, testid: "pipeline-step-script" },
  { key: "voiceover", label: "Music (Suno)", icon: Music, testid: "pipeline-step-voiceover" },
  { key: "visuals", label: "Footage", icon: Film, testid: "pipeline-step-visuals" },
  { key: "assembly", label: "Lyric Captions", icon: Clapperboard, testid: "pipeline-step-assembly" },
  { key: "completed", label: "Final Render", icon: PartyPopper, testid: "pipeline-step-done" },
];

const COMPILATION_STEPS = [
  { key: "script", label: "Downloading Videos", icon: Download, testid: "pipeline-step-script" },
  { key: "voiceover", label: "Combining Video", icon: Clapperboard, testid: "pipeline-step-voiceover" },
  { key: "visuals", label: "SEO Copywriting", icon: FileText, testid: "pipeline-step-visuals" },
  { key: "assembly", label: "AI Thumbnail", icon: ImageIcon, testid: "pipeline-step-assembly" },
  { key: "completed", label: "Uploaded", icon: PartyPopper, testid: "pipeline-step-done" },
];

const ORDER = ["pending", "script", "voiceover", "visuals", "assembly", "completed"];

export const PipelineTracker = ({ status, message, kind }) => {
  const STEPS = kind === "song" ? SONG_STEPS : kind === "compilation" ? COMPILATION_STEPS : VIDEO_STEPS;
  const currentIndex = ORDER.indexOf(status === "pending" ? "script" : status);
  const failed = status === "failed";

  return (
    <div data-testid="pipeline-status-tracker" className="bg-slate-900/60 border border-slate-800/80 rounded-2xl p-6 backdrop-blur-md">
      <div className="flex items-center justify-between gap-2 overflow-x-auto no-scrollbar pb-2">
        {STEPS.map((step, idx) => {
          const stepOrderIdx = ORDER.indexOf(step.key);
          const isDone = !failed && stepOrderIdx < currentIndex;
          const isActive = !failed && stepOrderIdx === currentIndex;
          const isFailedHere = failed && stepOrderIdx === currentIndex;
          const Icon = step.icon;
          return (
            <div key={step.key} data-testid={step.testid} className="flex-1 flex flex-col items-center gap-2 min-w-[96px]">
              <div
                className={`w-11 h-11 rounded-full flex items-center justify-center border transition-all ${
                  isFailedHere
                    ? "bg-red-500/10 border-red-500/40 text-red-400"
                    : isDone
                    ? "bg-emerald-500/10 border-emerald-500/30 text-emerald-400"
                    : isActive
                    ? "bg-amber-500/10 border-amber-500/40 text-amber-400 pipeline-pulse"
                    : "bg-slate-800/60 border-slate-700 text-slate-500"
                }`}
              >
                {isFailedHere ? (
                  <XCircle className="w-5 h-5" />
                ) : isDone ? (
                  <CheckCircle2 className="w-5 h-5" />
                ) : isActive ? (
                  <Loader2 className="w-5 h-5 animate-spin" />
                ) : (
                  <Icon className="w-5 h-5" />
                )}
              </div>
              <span className={`text-[11px] font-mono text-center leading-tight px-1 ${isActive ? "text-amber-400" : isDone ? "text-emerald-400" : "text-slate-500"}`}>
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
      <p className={`text-sm font-mono mt-3 ${failed ? "text-red-400" : "text-slate-400"}`}>{message}</p>
    </div>
  );
};
